import { useState } from 'react';

import { MaudPermissions } from '~/lib/constants/permissions.constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

import BasicInfo from '../basic-info';
import BillingPeriods from '../billingPeriods';
import PatientContacts from '../contact';
import PatientCoverages from '../coverage';
import PatientAppSettings from '../patient-app-settings';

interface PatientProfileTabProps {
  assessmentList: SurveyResponse[];
  patientId: string;
}
const PatientProfileTab = ({
  assessmentList,
  patientId,
}: PatientProfileTabProps) => {
  const { permissions } = useGlobalContext();
  const hasPatientDashboardPermission =
    permissions[MaudPermissions.MAUD_PATIENT_DASHBOARD];
  const isCarePlanPermissionsEnabled =
    permissions[MaudPermissions.MAUD_CARE_PLAN];
  const [patientBasicDetails, setPatientBasicDetails] = useState<Patient>(null);

  return (
    <>
      <BasicInfo
        assessmentList={assessmentList}
        hasPatientDashboardPermission={hasPatientDashboardPermission}
        patientBasicDetails={patientBasicDetails}
        patientId={patientId}
        setPatientBasicDetails={setPatientBasicDetails}
      />
      <PatientContacts
        hasPatientDashboardPermission={hasPatientDashboardPermission}
        patientBasicDetails={patientBasicDetails}
        patientId={patientId}
      />
      <PatientCoverages
        hasPatientDashboardPermission={hasPatientDashboardPermission}
        patientBasicDetails={patientBasicDetails}
        patientId={patientId}
      />
      <BillingPeriods
        isCarePlanPermissionsEnabled={isCarePlanPermissionsEnabled}
      />
      <PatientAppSettings
        hasPatientDashboardPermission={hasPatientDashboardPermission}
        patientBasicDetails={patientBasicDetails}
        setPatientBasicDetails={setPatientBasicDetails}
      />
    </>
  );
};

export default PatientProfileTab;
